export default class WarehousesFiltersModel {
    selectedWarehouseId: number;
    selectedCartId: number;
    selectedBinId: number;
}